var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 254,
  height: 99,
  viewBox: "0 0 254 99",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#line_svg__filter0_d_4419_3669)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M245.396 2.09248C248.513 3.22697 250.133 6.68006 248.857 9.74222C239.217 32.8946 223.16 52.8637 202.523 67.26C180.242 82.8039 153.707 91.094 126.539 90.9992C99.3718 90.9044 72.8953 82.4292 50.7228 66.7302C30.1871 52.1901 14.2699 32.1093 4.79127 8.89026C3.53762 5.81927 5.18159 2.37759 8.30641 1.26489V1.26489C11.4312 0.152188 14.8524 1.79056 16.12 4.85581C24.7599 25.7479 39.1463 43.8154 57.664 56.9267C77.8188 71.1971 101.886 78.9011 126.581 78.9873C151.276 79.0735 175.397 71.5377 195.651 57.4084C214.259 44.4267 228.772 26.46 237.557 5.62876C238.846 2.57244 242.279 0.957996 245.396 2.09248V2.09248Z",
  fill: "#302FA0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "line_svg__filter0_d_4419_3669",
  x: 0.369141,
  y: 0.915527,
  width: 252.926,
  height: 98.0845,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.14902 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4419_3669"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4419_3669",
  result: "shape"
})))));
export { SvgLine as ReactComponent };
export default __webpack_public_path__ + "assets/icons/line.f2909c.svg";